import { useSearchParams } from "next/navigation";
import { useEffect, useRef } from "react";
import { useAtomValue, useSetAtom } from "jotai";
import {
  startTourSetter,
  hasTourableNodesAtom,
  isTourOrExplanationRunningAtom,
  togglesAtom,
} from "@zapier/canvas-state";
import { useCopilotChat } from "@zapier/ai-toolkit/client";

export function useStartTourFromQueryParams() {
  const searchParams = useSearchParams();
  const tourSearchParam = searchParams?.get("tour");
  const shouldStartTour = tourSearchParam === "true";
  const hasStartedTour = useRef(false);
  const startTour = useSetAtom(startTourSetter);
  const hasTourableNodes = useAtomValue(hasTourableNodesAtom);
  const isTourOrExplanationRunning = useAtomValue(
    isTourOrExplanationRunningAtom,
  );
  const toggles = useAtomValue(togglesAtom);

  const copilot = useCopilotChat();

  useEffect(() => {
    if (
      shouldStartTour &&
      !hasStartedTour.current &&
      hasTourableNodes &&
      !isTourOrExplanationRunning
    ) {
      hasStartedTour.current = true;

      // Auto-start tour location #1: From query params (when navigating from AI/template pages)
      // Note: There are 2 places where tour can auto-start - this is one, and executeZslAndSaveSetter is the other
      // If the user has enabled the AI Copilot Cobuild toggle, don't start the tour
      // Copilot has the buttons that suggest to start the tour
      if (toggles.aiCopilotCobuild) {
        return;
      }

      startTour({
        copilot,
      }).catch((error) => {
        console.error("Failed to start tour from query params:", error);
      });
    }
  }, [
    shouldStartTour,
    hasTourableNodes,
    isTourOrExplanationRunning,
    copilot,
    startTour,
    toggles.aiCopilotCobuild,
  ]);
}
